import React from 'react';
import euSectionFImage from '../../assets/images/ui/EU-section-with-F.png';
import { useTheme } from '../../hooks/useTheme';

interface LicensePlateProps {
    number: string;
    department?: string;
    regionIcon?: string;
}

const LicensePlate: React.FC<LicensePlateProps> = ({ number, department, regionIcon }) => {
    const { muiTheme } = useTheme();
    return (
        <div
            className="border-radius-5px border fx-r w-100px of-y-hidden fx-justify-c"
            style={{
                borderColor: muiTheme.palette.text.secondary,
                minWidth: '100px',
                width: 'fit-content',
                maxWidth: '100%',
            }}
        >
            <div className="bg-euro text-white fx-c fx-items-c pad-l-3px pad-r-3px font-w-700">
                <img alt="F" height={23} src={euSectionFImage} />
            </div>
            <div className="fx-r fx-fg-1 fx-justify-c fx-items-c">
                <div className="font-w-700" style={{ fontFamily: 'monospace', whiteSpace: 'nowrap' }}>
                    {number}
                </div>
            </div>
        </div>
    );
};

export default LicensePlate;
